import React, { PureComponent } from "react";
import { Field, reduxForm } from "redux-form";
import { Button, ButtonToolbar, Modal } from "reactstrap";
import PropTypes from "prop-types";
import API from '../../../Common/api';
import { addAnalytics } from '../../../Common/analytics';



const url = window.location.hostname;
const google = window.google;
var port = window.location.port;

class LogInForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.onLogin = this.onLogin.bind(this);
    this.state = {
      username: "",
      new_password: "",
      showPassword: false,
      showNewPassword: false,
      showConfirmPassword: false,
      showUserNameMsg: false,
      showPassMsg: false,
      showLocationUI: false,
      locationNotSelected: false,
      showLoginUi: true,
      selectedLocations: "",
      location_list: [],
      locationModal: false,
      Failedmodal: false,
      failed_message: [],
      success_message: '',
      Successmodal: false,
      userName: '',
      loading: false,
      input_error : false
    };

    this.showNewPassword = this.showNewPassword.bind(this);
  }

  showNewPassword(e) {
    e.preventDefault();
    this.setState((prevState) => ({ showNewPassword: !prevState.showNewPassword }));
    
  }

  Failedtoggle = () => {
    this.setState((prevState) => ({ Failedmodal: !prevState.Failedmodal }));
  }
  Successtoggle = () => {
    this.setState((prevState) => ({ Successmodal: !prevState.Successmodal }));
  }


  componentWillMount() {
    if (port == 8091) {
      port = "8090";
    } else if (port == 8098) {
      port = "8099";
    } else {
      port = "8088";
    }
  }

  locationToggle = () => {
    this.setState((prevState) => ({ locationModal: !prevState.locationModal }));
  }

  handleUserName = (e) => {
    this.setState({
      username: e.target.value,
      input_error : false
    });
  };
  handleNewPassword = (e) => {
    this.setState({
      new_password: e.target.value,
      showPassMsg : false
    });

  };

  changeLocation = (e) => {
    this.setState({
      locationNotSelected: false,
      selectedLocations: e.target.value,
    });
  };

  createCookie = (cookieName, cookieValue, daysToExpire) => {
    var date = new Date();
    date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000);
    document.cookie =
      cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
  };

  deleteCookie = (name) => {
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  };
  getCookie = (cname) => {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }


  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  _handleKeyDown(e) {
    if (e.key === "Enter") {
      this.onLogin();
    }
  }

  _handleKeyDown1(e) {
    if (e.key === "Enter") {
      this.onLocation();
    }
  }
  // required = (value) => (value ? undefined : this.setState({input_error: true}));


  onLogin() {
    this.setState({
      loading: true
    })
    if (!this.state.username && !this.state.password){
      this.setState({
        loading : false,
        input_error : true,
        showPassMsg : true
      })
    }
    else if (!this.state.username) {
      this.setState({
        input_error: true,
        loading: false
      });
    } else if (!this.state.new_password) {
      this.setState({
        showPassMsg: true,
        loading: false
      });
    }
    else {
      addAnalytics('Password Reset', 'Admin')

      const payload = {
        user_name: this.state.username,
        new_password: this.state.new_password,
      };

      API.post('/auth/admin/reset-password/', { param: payload })
        .then((response) => {
          if (response.data.success == true) {
            this.setState({
              Successmodal: true,
              success_message: response.data.message,
              loading: false
            });
          } else {
            this.setState({
              Failedmodal: true,
              failed_message: response.data.password_errors[0],
              loading: false
            });
          }
        }).catch(function (error) {
          this.setState({
            Failedmodal: true,
            failed_message: error.response.data.password_errors,
            loading: false
          });
        }.bind(this));
    }
  }

  render() {
    const { handleSubmit } = this.props;
    const { showNewPassword, Failedmodal, Successmodal } = this.state;

    return (
      <div>
        <form style={{ margin: 'auto', marginTop: '7%', alignItems: 'center', flexDirection: 'column' }} className="form" onSubmit={handleSubmit}>
          {this.state.showLoginUi && (
            <div style={{ marginLeft: 10 }}>
              <div className="form__form-group">

              </div>
              <div className="form__form-group" style={{ marginTop: 25 }}>
                <div className="form__form-group-field" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '20px' }}>
                  <p style={{ margin: '0px 0px 8px 5px', alignSelf: 'flex-start', fontSize: '16px' }}>Username</p>

                  <div style={{ display: 'flex', alignItems: 'center', border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#fff', width: '312px' }}>
                    <Field
                      name="username"
                      component="input"
                      placeholder="User Name"
                      value={this.state.username}
                      onChange={this.handleUserName}
                      onKeyDown={(e) => this._handleKeyDown(e)}
                      style={{
                        border: 'none',
                        outline: 'none',
                        height: '44px',
                        flex: 1,
                        paddingLeft: '10px',
                        fontSize: '14px',
                        width: 400
                      }}
                      />

                  </div>
                  
                </div>
                {this.state.input_error && (
                  <div>
                    <h5 style={{ color: "red", marginLeft: "5px" }}>
                      UserName is Required
                    </h5>
                  </div>
                )}
              </div>
              <div className="form__form-group" style={{ marginTop: 25 }}>
                <div className="form__form-group-field" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '20px' }}>
                  <p style={{ margin: '0px 0px 8px 5px', alignSelf: 'flex-start', fontSize: '16px' }}>New Password</p>

                  <div style={{ display: 'flex', alignItems: 'center', border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#fff', width: '312px' }}>
                    <Field
                      name="new_password"
                      component="input"
                      type={showNewPassword ? "text" : "password"}
                      placeholder="New Password"
                      value={this.state.new_password}
                      onChange={this.handleNewPassword}
                      onKeyDown={(e) => this._handleKeyDown(e)}
                      style={{
                        border: 'none',
                        outline: 'none',
                        height: '44px',
                        flex: 1,
                        paddingLeft: '10px',
                        fontSize: '14px',
                        width: 400
                      }}
                    />

                    <div
                      className="form__form-group-icon"
                      style={{ padding: '0 10px', cursor: 'pointer' }}
                      onClick={(e) => this.showNewPassword(e)}
                    >
                      <img
                        src={require("../../../../images/eye.svg")}
                        alt="Show Password"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </div>
                  </div>
                </div>

                {this.state.showPassMsg && (
                  <div>
                    <h5 style={{ color: "red", marginLeft: "5px" }}>
                      Incorrect Password !!
                    </h5>
                  </div>
                )}
              </div>

              <div style={{ marginTop: "35px" }}>
                <Button className="btn-lg button_enable" onClick={this.onLogin} disabled={this.state.loading}>
                  {this.state.loading &&
                    <i
                      className="fa fa-refresh fa-spin"
                      style={{ marginRight: "5px" }}
                    />
                  }
                  Reset
                </Button>
              </div>


            </div>

          )}
        </form>

        <Modal isOpen={Failedmodal} backdrop="static" toggle={this.Failedtoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.Failedtoggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "red" }}
            />
            {/* <h4>{this.state.failed_message} </h4> */}
            <h4 style={{ textAlign: 'center', margin: '10px 20px 0px 20px' }}>
              {this.state.failed_message.map((line, index) => (
                <div key={index}>
                  {line.trim()}
                </div>
              ))}
            </h4>



          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.Failedtoggle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>
        <Modal isOpen={Successmodal} backdrop="static" toggle={this.Successtoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.Successtoggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "green" }}
            />
            <h4>{this.state.success_message} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              // onClick={this.Successtoggle}
              onClick={() => window.location.href = '/dashboard'}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>


      </div>
    );
  }
}

export default reduxForm({
  form: "log_in_form", // a unique identifier for this form
})(LogInForm);

